import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

interface AdminPageHeaderProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: Array<{ label: string; path?: string }>;
  action?: React.ReactNode;
}

/**
 * AdminPageHeader - Consistent page header for admin pages
 *
 * Features:
 * - Title and subtitle
 * - Breadcrumb navigation
 * - Optional action button/component
 *
 * TODO: Add back button for detail pages
 */
export default function AdminPageHeader({
  title,
  subtitle,
  breadcrumbs,
  action,
}: AdminPageHeaderProps) {
  const navigate = useNavigate();

  return (
    <Box sx={{ mb: 4 }}>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          sx={{ mb: 1 }}
        >
          {breadcrumbs.map((crumb, index) => (
            <Link
              key={index}
              color={crumb.path ? 'inherit' : 'text.primary'}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (crumb.path) {
                  navigate(crumb.path);
                }
              }}
              sx={{
                cursor: crumb.path ? 'pointer' : 'default',
                textDecoration: 'none',
                '&:hover': crumb.path ? { textDecoration: 'underline' } : {},
              }}
            >
              {crumb.label}
            </Link>
          ))}
        </Breadcrumbs>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>

        {action && <Box>{action}</Box>}
      </Box>
    </Box>
  );
}
